<perfect-scrollbar>
    <div class="log-message" *ngFor="let log of logs">
        {{ log }}
    </div>
</perfect-scrollbar>
